import * as TypeGraphQL from "type-graphql";
export var AlertType;
(function (AlertType) {
    AlertType["SUCCESS"] = "SUCCESS";
    AlertType["WARNING"] = "WARNING";
    AlertType["ERROR"] = "ERROR";
    AlertType["INFO"] = "INFO";
})(AlertType || (AlertType = {}));
TypeGraphQL.registerEnumType(AlertType, {
    name: "AlertType",
    description: undefined,
});
//# sourceMappingURL=AlertType.js.map